import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import i1 from "../../../Assets/images/user.png";

// img
import u1 from "../../../Assets/images/authbg.png";
import { Link } from "react-router-dom";
import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import dataHandler from "../../../hooks/dataHandler";
import {
  DELETE_SERVICE_CATEGORY,
  SERVICE_CATEGORY_LIST,
} from "../../../services/ApiCalls";
import CustomPagination from "../../../components/Common/CustomPagination";
import TableActions from "../../../components/Common/TableActions";
import moment from "moment";
import Filter from "../../../components/Common/Filter";
import { activeInactiveOptions } from "../../../utilities/const";
import { components } from "react-select";
import { removeUnderScoreAndCapitalizeFirstLetter } from "../../../utilities/utilities";

const ManageServiceCategory = () => {
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: SERVICE_CATEGORY_LIST,
  });

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    {
      head: "Image",
      accessor: "catImage.link",
      component: (item) => {
        return (
          <>
            <img src={item?.catImage?.link || i1} height={50} width={50} />
          </>
        );
      },
    },
    { head: "Name", accessor: "catName" },
    {
      head: "Created At",
      accessor: "createdAt",
      component: (item, key, arr) => (
        <>{moment(item.date_created_utc).format("DD-MM-YYYY")}</>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      component: (item, key) => {
        return <p>{removeUnderScoreAndCapitalizeFirstLetter(item.status)}</p>;
      },
    },
    {
      head: "Action",
      accessor: "Action",
      component: (item, key, arr) => {
        console.log(item, "item");
        return (
          <TableActions
            editUrl={`/manage-service-category/edit/${item._id}`}
            viewLink={`/manage-service-category/detail/${item._id}`}
            setDeleteModel={() =>
              setDeleteModel({ show: true, dumpId: item?._id })
            }
          />
        );
      },
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() =>
          setDeleteModel({
            show: false,
            dumpId: "",
          })
        }
        confirmHandler={() =>
          deleteHandler(() =>
            DELETE_SERVICE_CATEGORY({ _id: deleteModel.dumpId })
          )
        }
      />{" "}
      <ConfirmationPop
        confirmation={deleteModel.show}
        // setConfirmation={() => deleteModel(defaultDeleteModelState)}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        type={"delete"}
        confirmHandler={() =>
          deleteHandler(() =>
            DELETE_SERVICE_CATEGORY({ _id: deleteModel.dumpId })
          )
        }
      />
      <section className="manageServiceCategory py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Category List
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    {/* <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Import CSV
                      </Button>
                    </li>
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Export CSV
                      </Button>
                    </li> */}
                    <li className="">
                      <Link
                        to="/manage-service-category/add"
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        Add New
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageServiceCategory;
